// @ts-strict-ignore
import React, {FC} from 'react';

import {useTranslation} from 'common/i18n/hooks';
import common from 'iron/common/onboarding/immersive-onboarding/steps/common.module.styl';
import {ButtonBar} from 'iron/common/onboarding/immersive-onboarding/components/tile-button-bar';
import {ActionButton} from 'iron/common/onboarding/immersive-onboarding/components/action-button';
import {TrackingEvent, TrackingProperty, trackOnboardingEvent} from 'common/onboarding/immersive-onboarding/tracking';
import {Step} from 'common/onboarding/immersive-onboarding/types';

export const NeedHelpTileButtons: FC = () => {
  const {t} = useTranslation();

  const AUTOCAPTURE_DOCS = `https://docs.mixpanel.com/docs/tracking-methods/autocapture`;
  const SESSION_REPLAY_DOCS = `https://docs.mixpanel.com/docs/session-replay`;
  const CONTACT_SUPPORT = `https://mixpanel.com/get-support`;

  return (
    <ButtonBar className={common.mt42} heading={t(`onboarding.verify.need-help`)}>
      <ActionButton
        icon='externalLink'
        href={AUTOCAPTURE_DOCS}
        onClick={() => {
          trackOnboardingEvent(TrackingEvent.LinkClicked, {
            [TrackingProperty.CurrentStep]: Step.Verify,
            [TrackingProperty.LinkSource]: TrackingEvent.AutocaptureDocLink,
          });
        }}
        target='_blank'
      >
        {t(`onboarding.verify.autocapture-docs`)}
      </ActionButton>
      <ActionButton
        icon='replay'
        href={SESSION_REPLAY_DOCS}
        onClick={() => {
          trackOnboardingEvent(TrackingEvent.LinkClicked, {
            [TrackingProperty.CurrentStep]: Step.Verify,
            [TrackingProperty.LinkSource]: TrackingEvent.SessionReplayDocLink,
          });
        }}
        target='_blank'
      >
        {t(`onboarding.verify.session-replay-docs`)}
      </ActionButton>
      <ActionButton
        icon='help-center'
        href={CONTACT_SUPPORT}
        onClick={() => {
          trackOnboardingEvent(TrackingEvent.LinkClicked, {
            [TrackingProperty.CurrentStep]: Step.Verify,
            [TrackingProperty.LinkSource]: TrackingEvent.ContactSupportLink,
          });
        }}
        target='_blank'
      >
        {t(`onboarding.verify.contact-support`)}
      </ActionButton>
    </ButtonBar>
  );
};
